export const ADMIN_URL = '/admin'
export const AUTH_URL = '/auth'
